import { render, staticRenderFns } from "./rulesJoinFileSec.vue?vue&type=template&id=a706d6d0&scoped=true&"
import script from "./rulesJoinFileSec.vue?vue&type=script&lang=js&"
export * from "./rulesJoinFileSec.vue?vue&type=script&lang=js&"
import style0 from "./rulesJoinFileSec.vue?vue&type=style&index=0&id=a706d6d0&scoped=true&lang=css&"
import style1 from "./rulesJoinFileSec.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a706d6d0",
  null
  
)

export default component.exports